import script from "./AppLayoutStagingBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutStagingBar.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutStagingBar.vue?vue&type=style&index=0&id=1761670d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1761670d"]])

export default __exports__